import { useSessionOrNull } from '~/contexts/SessionContext';
import { Image3D } from '~/domain/patient/image3d';
import { createImageRegistrationsView } from '~/domain/projections/factories';
import { ImageRegistrationsView } from '~/domain/projections/views';
import { useDomainProjection } from './useDomainProjection';

/** Stable empty result for no session or no primary image. */
const EMPTY: ImageRegistrationsView[] = [];

/**
 * Returns the {@link ImageRegistrationsView} groups for `primaryImage`: one
 * entry per secondary image registered to it, each carrying the rigid
 * registrations linking it to the primary. The registration list UI consumes
 * these projections instead of navigating live `Patient`/`RigidRegistration`
 * entities.
 *
 * The grouping is relative to the primary image, so selecting another one
 * rebuilds it. Tolerates a missing session or a null primary image: the
 * panel can mount before a patient or image is chosen.
 */
export function useRegistrationListView(
    primaryImage: Image3D | null
): ImageRegistrationsView[] {
    return useDomainProjection(
        useSessionOrNull(),
        'useRegistrationListView',
        [primaryImage],
        (patient) =>
            primaryImage
                ? createImageRegistrationsView(patient, primaryImage)
                : EMPTY,
        EMPTY
    );
}
